import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.css'],
})
export class InputComponent implements OnInit {

    @Input() inputClass = '';
    @Input() placeholder = '';

    @Input() autofocus = false;

    @Input() value = '';
    @Output() valueChange = new EventEmitter<string>();

    @Input() maxlength = 1000;
    @Input() type = 'text';

    constructor() {
    }

    ngOnInit() {
    }

    onKeyUp(ev) {
        if (ev.target.value.length > this.maxlength) {
            ev.target.value = this.value;
            return;
        }

        this.value = ev.target.value;
        this.valueChange.emit(this.value);
    }

}
